import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { USER_MGMT_CNST } from "../../constants/proj.cnst";
import { AppStateService } from '../../services/app-state.service';


@Injectable({
  providedIn: "root"
})
export class ApiResponseInterceptor implements HttpInterceptor {
  constructor(private appStateSrv: AppStateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const customerUuid = this.appStateSrv.getCurrentCustomerId();
    const applicationUuid = this.appStateSrv.getApplicationId();
    let modifiedReq = req;
    if (customerUuid) {
      modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.set('customer-uuid', customerUuid) });
    }
    if (applicationUuid) {
      modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.set('application-uuid', applicationUuid) });
    }

    return next.handle(modifiedReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!req.url?.includes('json') && !req.url?.includes(USER_MGMT_CNST.API_MAPPING.GET_CSRF_TOKEN)) {
            const csrfToken = event.headers?.get('csrfToken');
            if (csrfToken) {
              localStorage.setItem('csrfToken', csrfToken);
            }
          }
        }
        return event;
      })
    );
  }
}
